import { render } from "./AsideMnue.vue?vue&type=template&id=2c38c4e0&scoped=true"
import script from "./AsideMnue.vue?vue&type=script&lang=js"
export * from "./AsideMnue.vue?vue&type=script&lang=js"

import "./AsideMnue.vue?vue&type=style&index=0&id=2c38c4e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c38c4e0"]])

export default __exports__